import * as cookie from 'js/lib/cookie';

declare global {
  interface Window {
    __STATSIG_STABLE_ID__?: string;
  }
}

/**
 * Returns the stableID for Statsig bucketing (CSR).
 * Priority: __204u cookie → window.__STATSIG_STABLE_ID__ (SSR-injected UUID fallback
 * for contexts where SameSite blocks the cookie, e.g. LTI iframes) → empty string.
 */
const getStableId = (): string => {
  return cookie.get('__204u') || window.__STATSIG_STABLE_ID__ || '';
};

export default getStableId;
